//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/importAccount/views/main/lan/en';
import sourceMigration from 'Modules/importAccount/views/main/.components/sourceMigration/lan/en';
import newMigration from 'Modules/importAccount/views/main/.components/newMigration/lan/en';
import exceptionDetails from 'Modules/importAccount/views/main/.components/exceptionDetails/lan/en';

locales = {
    ...locales,
    ...main,
    ...sourceMigration,
    ...newMigration,
    ...exceptionDetails,
};

export default locales;